import {DefaultTheme, Theme} from './theme';

// consistent with WeChat brand green
export const wechatColors = {
  brand: '#07C160',
  brandDark: '#06AD56',
  onBrand: '#FFFFFF',
  link: '#07C160',
};

export const WeChatTheme: Theme = {
  ...DefaultTheme,
  brandColor: wechatColors.brand,
  onBrandTextColor: wechatColors.onBrand,
  ctaColor: wechatColors.brand,
  ctaHoverColor: wechatColors.brandDark,
  onCtaTextColor: wechatColors.onBrand,
  linkColor: wechatColors.link,
  avatarGradientStart: wechatColors.brandDark,
  avatarGradientEnd: wechatColors.brand,
  headerBarGradient: `linear-gradient(to right, ${wechatColors.brandDark}, ${wechatColors.brand})`,
};
